export const config = {
  api_local: process.env.REACT_APP_API_URL, 
  BE_API_URL: process.env.REACT_APP_API_URL,
  site: process.env.REACT_APP_SITE,
  LIST_REQUEST_BANK: [
    "Thêm ngân hàng",
    "Sửa ngân hàng",
    "Thay đổi cả ngân hàng và họ tên",
    "Thay đổi tên ngân hàng",
  ],
  LIST_REQUEST_USDT: [
    "Vô Hiệu Hóa Ví USDT",
    "Thêm Ví USDT",
    "Đổi Ví USDT",
  ],
};